<div class="infinite-scroll-container" (scroll)="onScroll()">
  <ng-content></ng-content> 
  
  <div *ngIf="loading" class="loading-spinner">
    <app-shimmer-list [count]="10"></app-shimmer-list>
  </div>
</div>
